'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.969 19.005v1.33h1.995v-1.33h.666v1.662c0 .184-.15.333-.333.333h-2.661a.333.333 0 0 1-.333-.333v-1.662h.666ZM18.599 3c.185 0 .334.15.334.333v14.673a.333.333 0 0 1-.333.333H5.333A.333.333 0 0 1 5 18.006V3.333C5 3.149 5.15 3 5.333 3H18.6Zm-.332.666H5.666v14.007h12.6V3.666Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.933 10.214h.708c.66 0 1.156-.131 1.484-.392.328-.261.492-.642.492-1.141 0-.504-.137-.877-.413-1.117-.275-.24-.706-.36-1.293-.36h-.978v3.01Zm4.855-1.61c0 1.092-.34 1.926-1.023 2.504-.682.579-1.652.867-2.91.867h-.922v3.607h-2.15V5.442h3.239c1.23 0 2.165.264 2.806.794.64.53.96 1.319.96 2.368Z",
    fill: "currentColor"
  })));
});
var FwSet0Parking = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Parking = FwSet0Parking;